import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

export function FnrOverlayContents({ children, ...props }) {
  return <Wrapper {...props}>{children}</Wrapper>;
}

const Wrapper = styled(motion.div)`
  max-width: 540px;
  padding: 24px;
  box-sizing: border-box;
`;
